import { DogYearsPage } from '@web/components/dog-years-page';
import { DogYearsScreenProps } from 'shared/screens/dog-years';
import { withServerProps } from '@web/library/with-server-props';

export default function DogYears(props: DogYearsScreenProps) {
  return <DogYearsPage {...props} />;
}

export const getServerSideProps = withServerProps();
